
export default {
    props: {
        item: {
            type: Object
        }
    },
    data() {
        return {
            defaultImage: ""
        }
    },
    methods: {
        randomImage() {
            const vm = this;
            let tmpImageArray = [
                location.origin + "/img/public/img_default_01.png",
                location.origin + "/img/public/img_default_02.png",
                location.origin + "/img/public/img_default_03.png",
            ];
            tmpImageArray.sort(() => Math.random() - 0.5);
            tmpImageArray = tmpImageArray.slice(0, 1);
            let tmpImage = tmpImageArray[0];
            let newImg = new Image();
            let tmpReImage = vm.item.image;
            newImg.src = tmpReImage;
            newImg.onerror = () => {
                vm.defaultImage = tmpImage;
            };
            newImg.onload = () => {
                vm.defaultImage = newImg.src;
            };
        }
    },
    mounted() {
        this.randomImage();
    }
}
